import {
  CLOSE_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG,
  OPEN_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG,
  GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS,
  GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_ERROR,
  GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_SUCCESS
} from './PurchaseOrderChangeStatusDialog.actions'

const quotePurcharseOrderChangeStatusState = {
  error: false,
  loading: false,
  open: false,
  quotePurcharseOrderChangeStatus: []
}

/**
 * The PurchaseOrderChangeStatusDialog' reducer.
 */
const PurchaseOrderChangeStatusDialogReducer = (state = quotePurcharseOrderChangeStatusState, { payload, type }) => {
  switch (type) {
    case GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS: {
      return { ...state, loading: true }
    }
    case GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_ERROR: {
      return { ...state, loading: false }
    }
    case GET_QUOTE_PURCHASE_ORDER_CHANGE_STATUS_SUCCESS: {
      return {
        ...state,
        quotePurcharseOrderChangeStatus: payload.QuotePurcharseOrderChangeStatus,
        loading: false
      }
    }
    case CLOSE_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG: {
      return { ...state, open: false }
    }
    case OPEN_PURCHARSE_ORDER_CHANGE_STATUS_DIALOG: {
      return { ...state, open: true }
    }
    default: {
      return state
    }
  }
}

export default PurchaseOrderChangeStatusDialogReducer
